import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { BASE_URL, REGISTER_CENTER } from "../../API";
import axios from "axios";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";

function AddDiagnosticCenter() {
  const { headers, getCenters } = useContext(ProfileContext)

  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const response = await axios.post(BASE_URL + REGISTER_CENTER, data, { headers });
      if (response.data.code === 200 && response.data.status === true) {
        toast.success(response.data.message);
        reset();
        getCenters(1);
        navigate('/diagnostic-center-management')
      }
    }
    catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error || "An error occurred";
        toast.error(errorMessage);
      }
      else { toast.error("An error occurred") }
    }
    finally { setIsLoading(false) }
  }

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/diagnostic-center-management" }}>Diagnosis Center Management</Breadcrumb.Item>
                  <Breadcrumb.Item active >Add Center</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="notifi-list d-flex">
                <h6 className="comm_page_heading">Add Diagnosis Center</h6>
              </div>

              <div className="patient_referral_form">
                <div className="comm_border_box">
                  <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Center Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Name"
                            {...register("center_name", {
                              required: 'Please enter center name.',
                              validate: value => value.trim() !== "" || "Name cannot be Empty or just spaces.",
                            })}
                          />
                          {errors.center_name && <span className="error">{errors.center_name.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Email</Form.Label>
                          <Form.Control type="email" placeholder="Enter Your Email" {...register('email', {
                            required: "Please enter email address",
                            pattern: {
                              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "Invalid email address"
                            }
                          })} />
                          {errors.email && <span className='error'>{errors.email.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Address"
                            {...register("address", {
                              required: 'Please enter address.',
                              validate: value => value.trim() !== "" || "Address cannot be Empty or just spaces.",
                            })}
                          />
                          {errors.address && <span className="error">{errors.address.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Contact Number</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter contact number"
                            {...register("contact_number", {
                              required: 'Please enter Contact.',
                              validate: value => value.trim() !== "" || "Address cannot be Empty or just spaces.",
                            })}
                          />
                          {errors.contact_number && <span className="error">{errors.contact_number.message}</span>}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="modal_pair_btns patient_referral_btns ">
                      <button type="submit" className='main-btn' >Submit</button>
                      <button className='main-outline-btn' onClick={() => { navigate('/diagnostic-center-management') }}>Discard Changes</button>
                    </div>
                  </Form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddDiagnosticCenter;
